module.exports = __webpack_public_path__ + "f049ab7dbc4a8cc156d095610d816a60.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./www/assets/img/proyect-selected/anuncios/banner-hoja-producto.jpg
 ** module id = 573
 ** module chunks = 7
 **/